<div class="manipulation-grid-table">
  <arm-table [displayedColumns]="displayedColumns" [isSelectedByDefault]="false"
             [data]="manipulationData" [isMultipleSelection]="false"
             [isClientSide]="true" [isPagedTable]="false">
  </arm-table>
</div>
